
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useCallback } from 'react';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { TeamWithMembersData } from '../../../api/ApiTypes';
import { useAppEvent } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { TeamListItem } from '../new/teams/TeamListItem';

const useWorkspaceDetailQuery = (teamId: string) => {

    const api = useResolve(ApiClient);
    const qc = useQueryClient();

    const invalidate = useCallback(() => qc.invalidateQueries(['admin.teams.info']), [qc]);
    useAppEvent('workspace:members:add', invalidate);
    useAppEvent('workspace:members:remove', invalidate);
    useAppEvent('workspace:patch', invalidate);

    return useQuery({
        queryKey: ['admin.teams.info', teamId],
        queryFn: async () => api.exec(v2.admin.teams.info(teamId)),
    });
};

const emptyWorkspace: TeamWithMembersData = {
    id: '',
    type: 'team',
    label: '',
    description: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    members: [],
    invites: [],
};

export const WorkspaceInfoView = ({ workspaceId }: { workspaceId: string }) => {
    const { data } = useWorkspaceDetailQuery(workspaceId);
    return <TeamListItem team={data ?? emptyWorkspace} readonly />;
};


